export const DBConfig = {
    name: 'DHOHA_POWER',
    version: 1.1,
    objectStoresMeta: [
      {
        store: 'ADDFACT',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: [
            { name: 'FACTSINFO', keypath: 'FACTSINFO', options: { unique: false } },
        ]
      }
    ]
  };